import React from 'react';

import { Col } from 'react-bootstrap';
import Text from 'v3/components/Text';
import InputCurrency from 'v3/components/Input/Currency';
import { FaEye, FaEyeSlash, FaRegTrashAlt } from 'react-icons/fa';
import theme from 'v3/theme';
import * as S from './styles';

export default function ExtraFieldInputRow({
  label = '',
  value = 0,
  dollarValue = 0,
  showToDriver = false,
  onRemoveField = () => {},
  id,
}) {
  return (
    <S.ExtraFieldRow>
      <Col md={3}>
        <Text id={id ? `label-${id}` : undefined} type="regular">
          {label}
        </Text>
      </Col>
      <Col md={3}>
        <InputCurrency value={value} disabled id={id && `input-${id}-real`} />
      </Col>
      <Col md={3}>
        <InputCurrency value={dollarValue} disabled id={id && `input-${id}-dolar`} />
      </Col>
      <Col md={3}>
        <button type="button" id={id && `button-${id}-excluir`}>
          <FaRegTrashAlt color={theme.colors.danger} onClick={onRemoveField} title="Remover item" />
        </button>
        <button type="button" disabled style={{ background: 'transparent', cursor: 'default' }}>
          {showToDriver ? (
            <FaEye color={theme.colors.dark_blue} title="Motorista poderá visualizar este valor" />
          ) : (
            <FaEyeSlash color={theme.colors.dark_blue} title="Motorista não visualiza este valor" />
          )}
        </button>
      </Col>
    </S.ExtraFieldRow>
  );
}
